export default "__VITE_ASSET__eA0CXmGv__"